<template>
  <v-layout wrap>

    <v-flex xs12 v-if="coupons.length === 0">
      <small class="text-xs-center mx-auto" >No hay cupones disponibles</small>
    </v-flex>

    <template v-else>
      <v-flex xs12 md4 xl3 pa-1 v-for="(coupon, i) in coupons" :key="i">
        <coupon-card @click:edit="$emit('click:edit', coupon)" :internal="internal" :coupon="coupon"/>
      </v-flex>
    </template>

  </v-layout>
</template>

<script>
import CouponCard from "./CouponCard";
export default {
name: "CouponList",
  components: {CouponCard},
  props:{
    internal:{
      type: Boolean,
      default: false
    },
    coupons: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>